import {
    setCookie,
    initMenuTrigger,
    addHideScrolledMenuClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService,
    initLazyBg,
    initShow
} from './functions';



//import GLightbox from 'glightbox';
import './repo-search';
import './dsa-form';
import { initCategoryList } from './category-list';






const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    initShow('animUp');
    initShow('animDown');

    // init menu trigger
    initMenuTrigger();


    // add hideScrolledMenu class management based on scroll direction
    addHideScrolledMenuClass();



    //fix gallery id for slideshow ...
    addFancyboxFixForGallery('.wp-block-gallery');
    addFancyboxFixForGallery('.wp-block-image');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();

    initCategoryList();


}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {


        $('.wcag__fontSize').click(function (e) {
            e.preventDefault();
            $('.wcag__fontSize').removeClass('active');
            // $(this).addClass('active');
            $('.wcag__fontSize[data-class="' + $(this).data('class') + '"]').addClass('active');
            $('body,html').removeClass('let1 let2 let3');
            $('body,html').addClass($(this).data('class'));
            setCookie('fontSize', $(this).data('class'), 360);
            return false;
        });
        $('.wcag__contrast').click(function (e) {
            e.preventDefault();
            if ($('body,html').hasClass('cntrs')) {
                $('body,html').removeClass('cntrs');
                setCookie('contrast', 'cntrs', 0);
                $(this).removeClass('active');
            } else {
                $('body,html').addClass('cntrs');
                setCookie('contrast', 'cntrs', 360);
                $(this).addClass('active');
            }
            return false;
        });

        $(document.body).on('click', '.mainHeader__searchTrigger', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $('.mainHeader__search').toggleClass('show');
            $('.mainHeader__searchForm').toggleClass('show');
            $(this).toggleClass('show');
            return false;
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest('.mainHeader__search').length) {
                $('.mainHeader__search').removeClass('show');
                $('.mainHeader__searchForm').removeClass('show');
                $('.mainHeader__searchTrigger').removeClass('show');
            }
        });


        $('.subpageHeader__goDown').click(function () {
            const scrollTarget = $(this).offset().top;
            $('html,body').animate({ 'scrollTop': scrollTarget + 'px' }, 500);
        });

        $(document).on('click', '#primary-menu .menu-item-has-children', function (e) {
            if (window.innerWidth < 1200) {
                e.stopPropagation();
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                    $(this).parent().addClass('activeParent');
                    $('.mainHeader__menuBack').addClass('show');

                    $('.mainHeader__menuHolder')[0].scrollTop = 0;
                } else {
                    $(this).removeClass('active');
                    $(this).parent().removeClass('activeParent');
                }
            }
        });

        $(document).on('click', '.mainHeader__menuBack', function () {
            $('.activeParent:last').removeClass('activeParent');
            $('#primary-menu .menu-item.active:last').removeClass('active');
            if ($('#primary-menu .menu-item.active:last').length > 0) {
                // $('.mainHeader__menuBack').html($('.menu-item.active:last').find('>a').html());
            } else {
                // $('.mainHeader__menuBack').html('');
                $('.mainHeader__menuBack').removeClass('show');
            }
        });
        $(document).on('click', '.menuTrigger', function () {
            $('.activeParent').removeClass('activeParent');
            $('#primary-menu .menu-item.active').removeClass('active');
            $('.mainHeader__menuBack').removeClass('show');

        });


        const viewportWidth = window.innerWidth;
        $('#primary-menu  a[href*="|"]').each(function (e) {

            let url = $(this).attr('href');
            let split_url = url.split('|');
            if (viewportWidth <= 782) {
                $(this).attr('href', split_url[0]);
            } else {
                $(this).attr('href', split_url[1]);
            }
        });

        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();
            var target = $(this).attr('href');
            if (target.length > 1) {
                var targetOffset = $(target).offset().top - 140;
                $('html, body').animate({
                    scrollTop: targetOffset
                }, 500);
            }
            return false;
        });


        if (window.location.hash) {
            window.setTimeout(() => {
                var target = window.location.hash;
                if ($(target).length > 0) {
                    var targetOffset = $(target).offset().top - 140;
                    $('html, body').animate({
                        scrollTop: targetOffset
                    }, 500);
                }
            }, 500);

        }

        $('.gAtuty__menuItem').on('click', function () {
            const target = $(this).data('target');
            $('.gAtuty__menuItem').removeClass('active');
            $(this).addClass('active');
            $('.gAtuty__contentItem').removeClass('active');
            $(`.gAtuty__contentItem#${target}`).addClass('active');

        });





        /*
                const lightbox = GLightbox({
                    selector: ".woocommerce-product-gallery__image a,.glightbox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.glightbox a",
                    slideEffect: 'fade',
                    loop: true,
                    dragAutoSnap: true,
                });
                */

        const glightboxSelector = ".woocommerce-product-gallery__image a,.glightbox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.glightbox a";
        if ($(glightboxSelector).length > 0) {
            const base = (typeof ajaxParams !== 'undefined' && ajaxParams.themeUrl) ? ajaxParams.themeUrl : '';

            if (!document.querySelector('link[data-glightbox]')) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = base + '/plugins/glightbox/glightbox.min.css';
                link.dataset.glightbox = '1';
                document.head.appendChild(link);
            }

            const initLightbox = () => {
                if (typeof window.GLightbox !== 'function') return;
                window.GLightbox({
                    selector: glightboxSelector,
                    slideEffect: 'fade',
                    loop: true,
                    dragAutoSnap: true,
                });
            };

            if (typeof window.GLightbox === 'function') {
                initLightbox();
            } else if (!document.querySelector('script[data-glightbox]')) {
                const script = document.createElement('script');
                script.async = true;
                script.src = base + '/plugins/glightbox/glightbox.min.js';
                script.dataset.glightbox = '1';
                script.onload = initLightbox;
                document.head.appendChild(script);
            }
        }




    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);








